<template>
<b-overlay opacity="0.75" spinner-variant="primary" :show="$root.$data.bsLoader">
    <div class="body-wrapper">
        <nav-bar/>
        <b-container class="position-relative strata-table contacts" fluid>
            <div class="main-panel">
                <div class="db-content-wrapper">
                    <h2 class="page-title my-4">My Contacts</h2>
                        <div class="d-flex justify-content-between" style="align-items: center; flex-wrap: wrap;">
                            <div class="d-flex">
                                <router-link :to="{name: 'manager-contacts-contractors'}" :style="{'color':'grey', 'padding':'5px'}">     
                                    <h1 class="table-title">Contractor</h1>
                                </router-link>
                                <span style="font-size: 19px;position: relative;">/</span>
                                <router-link :to="{name: 'manager-contacts-building-managers'}" :style="{'color':'$primary', 'padding':'5px'}">     
                                    <h1 class="table-title" style="display:inline;font-weight:bold">Building Manager</h1>
                                </router-link>
                            </div>

                            <b-form @submit.prevent inline class="align-items-start">
                                <b-row :style="{'padding': '0px 15px'}">
                                    <b-col>
                                        <div class="position-relative f-b">
                                            <i class="fas fa-search search-icon" ></i>
                                            <b-form-input
                                              
                                                class="mb-2 mb-sm-0"
                                                placeholder=""
                                                v-model="filterQuery"
                                                @change="filter(1)"
                                            ></b-form-input>
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-form>
                        </div>

                    <div class="datagrid mb-4 mt-4">
                        <div class="datagrid-body">
                            <b-table
                                :busy="this.$root.loading"
                                :items="tableItems"
                                :fields="tableFields"
                                sort-icon-left
                                hover
                                responsive
                                show-empty
                            >
                          
                                <template v-slot:table-busy>
                                    <div class="text-center text-danger my-2">
                                        <b-spinner
                                            class="align-middle"
                                            :variant="'primary'"
                                        ></b-spinner>
                                    </div>
                                </template>

                                <template v-slot:cell(StrataPlanID)="row">
                                    <router-link
                                        :to="{
                                            name: 'manager-strataplan-view',
                                            params: { id: row.item.id },                              
                                        }"
                                    >{{row.item.StrataPlanID}}
                                    </router-link>
                                </template>
                                <template #empty class="text-center">
                                    No Data Found
                                </template>
                            </b-table>

                        </div>
                        <div class="datagrid-footer" v-if="lastPage > 1">
                            <b-pagination
                                pills
                                align="right"
                                :total-rows="total"
                                v-model="currentPage"
                                :page-count="lastPage"
                                :per-page="perPage"
                                :hide-goto-end-buttons="true"
                            ></b-pagination>
                        </div>
                    </div>
                </div>
            </div>

         <footer-component></footer-component>
        </b-container>


    </div>
    </b-overlay>
</template>

<script>
import NavBar from "../includes/NavBar.vue";
import _ from "lodash";
import moment from "moment";
import FooterComponent from "../../includes/FooterComponent.vue";
import { Treeselect, ASYNC_SEARCH } from "@riophae/vue-treeselect";
import phoneNoMixin from "../../../../mixins/phoneNoMixin";

export default {
    components: {
        NavBar,
        FooterComponent,
        Treeselect  
    },
    props: {
        filterStatus: String,
    },
    mixins: [phoneNoMixin],
    data() {
        return {
            currentPage: 1,
            total: 0,
            perPage: 50,
            lastPage: 1,
            tableItems: [],
            tableFields: [
                {key: '', sortable: true},
                {key: 'Name', sortable: true},
                {key: 'Phone', sortable: true},
                {key: 'Email', sortable: true},
                {key: 'StrataPlanID', sortable: true},
            ],
            filterQuery: "",
            // filterManager: this.$store.state.authenticatedUserData.user.id,
            filterManagerOptions: []
            // filterStatus: "all",
            // options: [
            //     {
            //     id: this.$store.state.authenticatedUserData.user.id,
            //     label: this.$store.state.authenticatedUserData.user.full_name + ' (My Quote)'
            //     },
            // ],
        };
    },
    mounted() {
        // console.log('prop', this.filterStatus);
        this.filter(1);
        this.loadOrganizationManager();
        // this.loadFilterManagerOptions();
    
    },
    methods: {
        filter(page = 1) {
            this.$root.$data.bsLoader = true;
            axios
                .post("api/manager/contacts/building-manager-filter", {
                    page: page,
                    per_page: 20,
                    filter_query: this.filterQuery,
                    // filter_manager_id: this.filterManager,
                    // filter_status: this.filterStatus,
                })
                .then((response) => {
                    this.currentPage = response.data.current_page;
                    this.total = response.data.total;
                    this.perPage = response.data.per_page;
                    this.lastPage = response.data.last_page;
              
                    this.tableItems = _.map(response.data.building_managers.data, (building_manager) => {
                        return {
                            id: building_manager.id,
                            Name: building_manager.building_manager_name,
                            Email: building_manager.building_manager_email,
                            Phone: building_manager.strata_manager_phone ? this.formatPhoneForAustraliaBySpace(building_manager.strata_manager_phone) : null,
                            StrataPlanID: building_manager.strata_plan_number,
                        };
                    });
                    this.$root.$data.bsLoader = false;
                }).catch((err) => {
                    this.$root.$data.bsLoader = false;
                });
        },
        loadOrganizationManager() {
            axios
                .post("api/content/getReplyToManagers")
                .then((response) => { 
                    this.filterManagerOptions = response.data.business_users.map((businessUser) => {
                        return {
                            id: businessUser.id,
                            label: businessUser.first_name + ' ' + businessUser.last_name,
                        };
                    });

                    //Adding all option at the beginnning of select option
                    this.filterManagerOptions.unshift({
                        id: 'all',
                        label: 'All'
                    });
                });
        },
        //For Searching Select
        // loadFilterManagerOptions({ action, searchQuery, callback }) {
        //     if (action === ASYNC_SEARCH) {
        //         axios
        //             .post("api/manager/manager/filter", {
        //                 search_query: searchQuery
        //             }, {
        //                 headers: {
        //                     'X-Disable-Root-Loading': 1,
        //                 }
        //             })
        //             .then(response => {
        //                 let filterManagerOptions = response.data.managers.map(manager => {
        //                     return {
        //                         id: manager.id,
        //                         label: `${manager.first_name} ${manager.last_name}`,
        //                     };
        //                 });
        //                 callback(null, filterManagerOptions);
        //             });
        //     }
        // },
    },

    watch: {
        currentPage: {
            handler: function (value) {
                this.filter(value);
            },
        },
    },
};
</script>

<style scoped>
    .body-wrapper
    {
        background-color: #F7F7FC !important;
        height: 100vh;
    }
    .page-title
    {
        font-size: 28px;
        font-weight: 600;
    }

    footer {
        margin-top: 9rem;
        margin-bottom: 1rem;
    }
</style>

